import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import type { TableView, MailListRowDataType } from 'owa-mail-list-store';

export interface ADD_INBOX_RULE_NOTIFICATIONActionMessage {
    row: MailListRowDataType;
    mailboxInfo: MailboxInfo;
    tableView: TableView;
}
const defaultExport: (
    row: MailListRowDataType,
    mailboxInfo: MailboxInfo,
    tableView: TableView
) => ADD_INBOX_RULE_NOTIFICATIONActionMessage = action(
    'ADD_INBOX_RULE_NOTIFICATION',
    (
        row: MailListRowDataType,
        mailboxInfo: MailboxInfo,
        tableView: TableView
    ): ADD_INBOX_RULE_NOTIFICATIONActionMessage => ({
        row,
        mailboxInfo,
        tableView,
    })
);
export default defaultExport;
